module.exports = __webpack_public_path__ + "54eb6ec9a704d6b00def42331813f4ac.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/doc.png
 ** module id = 26
 ** module chunks = 0
 **/